<template>
  <el-container class="question-container" direction="vertical" :class="`${question.id}`">
    <el-header class="question-header" height="auto">
      <div class="question-progress">{{ `${currentStep}/${allQuestions.length}` }}</div>
      <div class="question-title">
        <span class="step">{{ `Q${currentStep}` }}</span>
        <span class="title-container">
          <div class="title">{{ isEnglish ? question.en_title : question.cn_title }}</div>
          <div class="tip">{{ isTextQuestion ? '' : $t(`survey.questionType.${question.question_type}`) }}</div>
        </span>
      </div>
    </el-header>
    <el-main class="question-body" :class="question.question_type">
      <template v-if="isTextQuestion">
        <el-input
          v-model="question.result"
          ref="questionTextArea"
          class="question-textarea"
          type="textarea"
          :autosize="{ minRows: 4}"></el-input>
      </template>
      <template v-else>
        <QuestionSelect
          v-model="question.result"
          ref="questionSelect"
          :hasCityOptions="hasCityOptions"
          :optionList="getQuestionOptions(question)"
          :multiple="isMultiple"/>
      </template>
    </el-main>
  </el-container>
</template>

<script>
import _ from 'lodash'
import QuestionSelect from './questionSelect'
import { deviceType } from '@/utils/common'

export default {
  components: {
    QuestionSelect
  },
  props: {
    allQuestions: {
      type: Array,
      default: () => []
    },
    currentStep: {
      required: false
    },
    currentQuestion: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {

    }
  },
  computed: {
    isEnglish () {
      return this.$i18n.locale === 'en'
    },
    isPC () {
      return deviceType.isPc
    },
    question () {
      return this.currentQuestion
    },
    isMultiple () {
      return this.question.question_type === 'checkbox'
    },
    isTextQuestion () {
      return this.question.question_type === 'text'
    },
    hasFilterOptions () {
      return this.question.option_type === 'filter'
    },
    hasCityOptions () {
      return this.question.option_type === 'city'
    },
    hasCustomOptions () {
      return this.question.option_type === 'custom'
    },
    hasJobTypeOptions () {
      return this.question.option_type === 'job_type'
    },
    hasRoleTypeOptions () {
      return this.question.option_type === 'role_type'
    },
    selectedDisplayValue () {
      return this.$refs.questionSelect && this.$refs.questionSelect.checkedDisplayName
    }
  },
  created () {
    this.resetTexareaHeight()
  },
  methods: {
    resetTexareaHeight () {
      this.$nextTick(() => {
        if (!this.$refs.questionTextArea) {
          return
        }
        const textArea = this.$refs.questionTextArea.$el
        const textAreaEl = textArea.firstElementChild
        const minHeight = this.isPC ? textArea.clientHeight - 25 : textArea.clientHeight - 50
        textAreaEl.style.minHeight = `${minHeight}px`
      })
    },
    getQuestionOptions (question) {
      if (this.hasCityOptions) {
        const options = question.options
        return _.sortBy(options, ['name', 'cn_name'])
      } else {
        return question.options
      }
    }
  },
  watch: {
    question (newVal) {
      this.resetTexareaHeight()
    },
    selectedDisplayValue: {
      handler () {
        this.$emit('selectedChange', this.selectedDisplayValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.question-container {
  height: 1px; // it is no effect(even heigth=0), but if it has no height the el-main will no scroll bar

  .question-header {
    padding: 15px 20px 20px 0;
    min-height: 60px;

    .question-progress {
      text-align: right;
      color: #989898;
      font-size: 16px;
    }

    .question-title {
      display: flex;
      font-size: 22px;

      .step {
        display: inline-block;
        width: 35px;
        margin: 0 45px;
        vertical-align: middle;
      }

      .title-container {
        display: inline-block;
        vertical-align: text-top;

        .title {
          font-weight: bolder;
          word-break: break-word;
        }

        .tip {
          margin-top: 10px;
          height: 20px;
          font-size: 14px;
          color: #a5a5a5;
        }
      }
    }
  }

  .question-body {
    padding: 0 20px 0 125px;
    border-top: 1px solid #c7c7c7;

    &.text {
      padding: 0 20px 0 45px;
    }

    .question-textarea {
      padding-top: 25px;
      min-height: 100%;
      box-sizing: border-box;

      ::v-deep textarea {
        border-radius: 0;

        &:focus {
          border-color: #C0C4CC;
        }
      }
    }
  }
}

.is-mobile {
  .question-container {
    .question-header {
      padding: 10px 15px 10px 0;

      .question-title {
        font-size: 14px;
        display: initial;

        .step {
          margin-left: 20px;
        }

        .title-container {
          display: block;
          margin-top: 5px;
          margin-left: 20px;

          .tip {
            font-size: 12px;
          }
        }
      }
    }

    .question-body {
      padding-left: 20px;
      border-bottom: 1px solid #c7c7c7;

      .question-textarea {
        padding-bottom: 25px;
      }
    }
  }
}
</style>
